import React from 'react'
import { gql } from 'apollo-boost'

export type Menus = Menu[]
export interface Menu {
  id: number
  name: string
  categories: Category[]
}

export interface Category {
  id: number
  name: string
  items: Item[]
}

export interface Item {
  id: number
  name: string
  price: number
  minPrice: number
  maxPrice: number
}

export const MenusCtx = React.createContext<Menu | null>(null)

export const GET_RESTAURANT_MENU = gql`
query GetRestaurantMenus($restaurant_id: Int!) { 
  menus(restaurantId: $restaurant_id) {
  	id name categories 
    { id name 
      items { 
      	id
      	name 
      	price       
      	minPrice      
      	maxPrice
      }
    }
	}
}
`
